import Icon from "../../assets/img/icon/arrow-round.png";

// dynamically load all images from the gallery directory
const galleryContext = require.context(
  "../../assets/img/gallery",
  false,
  /\.(jpe?g|png)$/,
);

export const GalleryData = [
  ...galleryContext.keys().map((key) => ({
    img: galleryContext(key),
    icon: Icon,
  })),
];
